import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import Layout from "../../components/Layout";
import ServiceProductCard from "../../components/products/ServiceProductCard";
import { mockProducts } from "../../utils/mockData";

const Products = () => {
  const { t } = useTranslation("products");

  const sortedProducts = [...mockProducts].sort((a, b) => {
    if (a.isFeatured) return -1;
    if (b.isFeatured) return 1;
    return 0;
  });

  return (
    <Layout>
      <div className="py-4 md:py-8">
        <motion.div
          className="text-center mb-10 md:mb-14"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <p className="text-caption text-neon-green mb-3">
            {t("page_eyebrow")}
          </p>
          <h1
            className="text-h1 md:text-display text-gradient-brand mb-4"
            style={{ lineHeight: "125%" }}
          >
            {t("page_title")}
          </h1>
          <p
            className="text-body-lg text-gray-400 max-w-2xl mx-auto"
            style={{ lineHeight: "125%" }}
          >
            {t("page_subtitle")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 max-w-5xl mx-auto">
          {sortedProducts.map((product, index) => (
            <ServiceProductCard
              key={product.id}
              product={product}
              index={index}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Products;
